import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { Toaster } from 'sonner';
import { useRTL } from '@/i18n/rtl';
import '@/i18n/config';

export const App = () => {
  useRTL();

  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="top-center" />
    </>
  );
};
